import { Card, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function EmergencyQuickAccess() {
  const theme = useTheme()
  const navigate = useNavigate()
  const {t} = useTranslation()
  return (
    <Card
      sx={{
        p: 2,
        backgroundColor: theme.palette.error.main,
        '&:hover': {
          backgroundColor: theme.palette.error.dark,
          cursor: 'pointer',
        },
      }}
      onClick={() => navigate('/emergency')}
    >
      <Grid container alignItems="center" justifyContent="center">
        <Typography variant="h6" sx={{ color: 'white' }}>
          {t('page.home.emergencyQuickAccess')}
        </Typography>
      </Grid>
    </Card>
  )
}
